import { parseWidgetDataBeforeApiRequest } from '@utils/utils';
import { useExportQueryObjectWorkflow } from '../../../hooks/useExportQueryWorklflow';
import { useMetricsContextAsArray } from '../../../hooks/useMetricsContext';
import { cleanEmptyFilters } from '../../../utils/filterUtils';
import { useBuildQueryParams } from '../../Reports/hooks';
import { AllTypeWidgets, PivotTableTypeWidget, TableSubType, TopResults } from '../types';

export const useExportWidget = () => {
  const { mutate: exportQueryObjectWorkflow, isPending: isExporting } = useExportQueryObjectWorkflow();
  const measurements = useMetricsContextAsArray();

  const metricsWithAliases = useBuildQueryParams({
    headCellsIds: measurements.map(({ systemName }) => systemName),
    measurements,
  });

  const exportWidget = ({ widget, globalFilters }: { widget: Exclude<AllTypeWidgets, PivotTableTypeWidget>; globalFilters: any }) => {
    const requestTop = widget.requests[0]?.top;
    const parsedWidget = parseWidgetDataBeforeApiRequest({
      widget,
      metricsWithAliases,
    });
    const { top, ...rest } = parsedWidget.requests[0];

    const isTableWithoutTopN = widget.type === TableSubType.Table && !widget.definition.custom.topN;
    const exportTop: TopResults | undefined =
      requestTop && !isTableWithoutTopN && top ? { size: top.size, groupOthers: top.groupOthers } : undefined;

    exportQueryObjectWorkflow({
      contextFilter: cleanEmptyFilters(globalFilters),
      queryObject: {
        ...rest,
        ...(exportTop && { top: exportTop }),
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      name: widget.definition.title.title,
    });
  };

  return { exportWidget, isExporting };
};
